import React, { useContext, useEffect, useState } from "react";
import smoothscroll from "smoothscroll-polyfill";
import Icon from "@material-ui/core/Icon";
import { HamburgerSqueeze } from "react-animated-burgers";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import herings_logo_text from "../../assets/images/etc/herings_logo_text.png";
import herings_logo_b from "../../assets/images/etc/heringsLOGO_black.svg";
import herings_logo_w from "../../assets/images/etc/heringsLOGO_white.svg";
import herings_logo_m from "../../assets/images/etc/heringsLOGO_mobile.svg";
import { ReactComponent as HeringsLogo } from "../../assets/images/etc/heringsLOGO.svg";
import { ReactComponent as HeringsLogoDark } from "../../assets/images/etc/heringsLOGO_dark.svg";
import "./Menubar.css";
import { MediaQueryContext, ThemeContext } from "../../context";
import { MENU } from "./MenuList";
import { SUPPORTED_LANGS, DEFAULT_LANG } from "../../i18n";

const STORAGE_KEY = "lang";

const getLangFromPath = (pathname) => {
  const m = pathname.match(/^\/(kr|en)(\/|$)/);
  return m ? m[1] : DEFAULT_LANG;
};

const buildLangPath = (lang, path) => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `/${lang}${normalized}`;
};

const swapLang = (pathname, nextLang) => {
  const m = pathname.match(/^\/(kr|en)(\/.*)?$/);
  const tail = m ? m[2] || "" : pathname;
  return `/${nextLang}${tail || ""}` || `/${nextLang}`;
};

export default function Menubar(props) {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const pathname = location.pathname;
  const currentLang = getLangFromPath(pathname);
  const stripped = pathname.replace(/^\/(kr|en)/, "") || "/";

  smoothscroll.polyfill();
  const { mDesktop, mTablet, mobile } = useContext(MediaQueryContext);
  const [isOver, setIsOver] = useState(false);
  const [isMActive, setIsMActive] = useState(false);
  const [mobileSelected, setMobileSelected] = useState([]);
  const [, setIsScroll] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const { theme } = useContext(ThemeContext);

  const mobilemenuclick = (e, val) => {
    e.preventDefault();
    setMobileSelected((prev) =>
      prev.includes(val) ? prev.filter((v) => v !== val) : [...prev, val]
    );
  };

  const menuclick = () => {
    setIsMActive(false);
    setMobileSelected([]);
    setIsOver(false);
  };

  const onScroll = () => {
    setIsScroll(window.scrollY || window.pageYOffset > 0 ? true : false);
  };

  const menuover = (e) => {
    e.preventDefault();
    setIsOver(true);
  };

  const menuout = (e) => {
    e.preventDefault();
    setIsOver(false);
  };

  const onChangeLang = (nextLang) => {
    if (nextLang === currentLang) return;
    try {
      localStorage.setItem(STORAGE_KEY, nextLang);
    } catch (e) {}
    history.push(swapLang(pathname, nextLang) + (location.search || "") + (location.hash || ""));
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const renderLangSwitch = (variant = "desktop") => (
    <div className={`lang-switch lang-switch-${variant}`}>
      {SUPPORTED_LANGS.map((lng, i) => (
        <React.Fragment key={lng}>
          {i > 0 && <span className="lang-switch-sep">|</span>}
          <button
            type="button"
            className={`lang-switch-btn FontR textF14 ${
              lng === currentLang ? "lang-switch-active" : ""
            } ${theme === "light" || pathname === `/${currentLang}` ? "tcb" : "tcw"}`}
            onClick={() => onChangeLang(lng)}
          >
            {t(`common.lang.${lng}`)}
          </button>
        </React.Fragment>
      ))}
    </div>
  );

  if (mDesktop) {
    return (
      <div className="mobileMenuWrapDiv">
        <div
          className={`mobileMenuroot  ${
            theme === "dark" ? "menuBorderBottomDark" : "menuBorderBottomLight"
          }`}
          style={{ backgroundColor: theme === "dark" && "#282828" }}
          onMouseEnter={menuover}
          onMouseLeave={menuout}
        >
          <div className="mobileMenulogo ptb-10 flex align-items-center">
            <NavLink to={`/${currentLang}/`}>
              <div
                className="logoImgContainCenterM"
                style={
                  mobile
                    ? { backgroundImage: "url('" + herings_logo_text + "')" }
                    : theme === "light"
                    ? { backgroundImage: "url('" + herings_logo_text + "')" }
                    : { backgroundImage: "url('" + herings_logo_text + "')" }
                }
              ></div>
            </NavLink>

            <div className="buttons">
              {renderLangSwitch("mobile")}
              <div className="mobileBtn">
                <HamburgerSqueeze
                  className="mobileBtnHambuger"
                  isActive={isMActive}
                  toggleButton={() => setIsMActive((v) => !v)}
                  buttonWidth={25}
                  buttonColor={theme === "light" ? "#FFF" : "#282828"}
                  barColor={theme === "light" ? "black" : "white"}
                />
              </div>
            </div>
          </div>

          <div
            className={`sideOverlay ${isMActive ? "sideOverlayOn" : ""}`}
            onClick={() => setIsMActive(false)}
            aria-hidden="true"
          />

          <div className={`mobileMenus ${isMActive ? "slider" : "slideroff"}`}>
            {MENU.map((menu, idx) => {
              const hasMobileSub = menu.sub && menu.sub.length > 1;
              return (
                <div className="mobileMenuDiv" key={idx}>
                  <NavLink
                    to={{
                      pathname: buildLangPath(currentLang, menu.path),
                      hashId: menu.hashId,
                      update: Math.random(),
                    }}
                    onClick={(e) => {
                      if (hasMobileSub) {
                        mobilemenuclick(e, idx);
                      } else {
                        menuclick();
                      }
                    }}
                  >
                    <div className="mobileMenuRow">
                      <span
                        className={`FontEB textF22 menuText ${
                          mobileSelected.includes(idx) ? "mobilemenusactive" : ""
                        } ${theme === "light" ? "tcb" : "tcw"}`}
                      >
                        {t(menu.labelKey)}
                      </span>
                      {hasMobileSub &&
                        (mobileSelected.includes(idx) ? (
                          <Icon style={{ color: "#E78510" }}>expand_less</Icon>
                        ) : (
                          <Icon style={{ color: theme === "dark" && "#fff" }}>
                            expand_more
                          </Icon>
                        ))}
                    </div>
                  </NavLink>
                  {hasMobileSub && (
                    <ul
                      className={`mobileMenuul ${
                        mobileSelected.includes(idx)
                          ? "mobilemenuslider"
                          : "mobilemenuslideroff"
                      }`}
                    >
                      {menu.sub.map((sub, i) => (
                        <li key={i}>
                          <NavLink
                            style={{ display: "block", width: "100%", height: "100%" }}
                            to={{
                              pathname: buildLangPath(currentLang, sub.path),
                              hashId: sub.hashId,
                              update: Math.random(),
                            }}
                            onClick={menuclick}
                          >
                            <span
                              className={`menuText textF18 FontB ${
                                theme === "light" ? "tcg" : "tcw"
                              }`}
                            >
                              {t(sub.labelKey)}
                            </span>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  } else {
    const isHome = stripped === "/";
    return (
      <div
        className={`menuWrapDiv position-fixed w-full flex-col ${
          !isHome
            ? theme === "dark"
              ? "menuBorderBottomDark"
              : "menuBorderBottomLight"
            : ""
        }`}
        style={{
          backgroundColor:
            isHome ? "#ffffff" : theme === "dark" ? "#282828" : "#ffffff",
          color: theme === "dark" && "#ffffff",
        }}
        onMouseEnter={menuover}
        onMouseLeave={menuout}
      >
        <div className="menuWrap">
          <NavLink to={`/${currentLang}/`}>
            <div className="logoImgContainCenter">
              <img
                src={herings_logo_text}
                alt="HERINGS"
                className="headerLogoImg"
              />
            </div>
          </NavLink>

          <div className="menusAfterLogo">
            {MENU.map((menu, idx) => {
              const hasDropdown = menu.sub && menu.sub.length > 1;
              const aboutPaths = ["/whoweare/", "/heringsteam/", "/irinformation/", "/aboutus/"];
              const servicePaths = ["/rpmsolution/", "/healthcare/", "/clinicalresearch/"];
              const isActive =
                stripped === menu.path ||
                (idx === 0 && aboutPaths.includes(stripped)) ||
                (idx === 1 && servicePaths.includes(stripped)) ||
                (/^\/news\/\d+$/.test(stripped) && menu.path === "/news/");
              return (
                <div
                  className="menudiv"
                  key={idx}
                  style={hasDropdown ? { position: "relative" } : {}}
                  onMouseEnter={hasDropdown ? () => setDropdownOpen(idx) : undefined}
                  onMouseLeave={hasDropdown ? () => setDropdownOpen(null) : undefined}
                >
                  <NavLink
                    to={{
                      pathname: buildLangPath(currentLang, menu.path),
                      hashId: menu.hashId,
                      update: Math.random(),
                    }}
                    onClick={menuclick}
                  >
                    <span
                      className={`menuText textF18 FontR ${
                        isActive
                          ? "menuTextActive"
                          : theme === "light" || isHome
                          ? "tcb"
                          : "tcw"
                      }`}
                    >
                      {t(menu.labelKey)}
                    </span>
                  </NavLink>
                  {hasDropdown && dropdownOpen === idx && (
                    <div
                      className="menu-dropdown"
                      style={{
                        backgroundColor: theme === "dark" ? "#282828" : "#fff",
                      }}
                    >
                      {menu.sub.map((sub, i) => (
                        <NavLink
                          key={i}
                          to={{
                            pathname: buildLangPath(currentLang, sub.path),
                            hashId: sub.hashId,
                            update: Math.random(),
                          }}
                          onClick={() => {
                            setDropdownOpen(null);
                            menuclick();
                          }}
                          className="menu-dropdown-item"
                        >
                          <span
                            className={`textF15 FontR ${
                              theme === "light" || isHome ? "tcb" : "tcw"
                            }`}
                          >
                            {t(sub.labelKey)}
                          </span>
                        </NavLink>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
            {renderLangSwitch("desktop")}
          </div>
        </div>
      </div>
    );
  }
}
